import { translateMessage } from '../../../../../utils/locale';
import type { StudioPageContent } from '../constants';

const resolveLocale = (locale?: string) => locale || 'zh-Hant-HK';

const t = (id: string, locale?: string) => translateMessage(id, resolveLocale(locale)) || '';

/** Shared copy for classic / editorial / spotlight — design differs, wording stays the same. */
export const studioCopy = {
  learnMore: (locale?: string) => t('hot-topic-studio-fallback-learn-more', locale),
  readyForward: (locale?: string) => t('hot-topic-studio-fallback-ready-forward', locale),
  notGoodToGo: (locale?: string) => t('hot-topic-studio-fallback-not-good-to-go', locale),
  goodToGo: (locale?: string) => t('hot-topic-studio-fallback-good-to-go', locale),
  leftItems: (locale?: string) => [
    t('hot-topic-studio-fallback-left-1', locale),
    t('hot-topic-studio-fallback-left-2', locale),
    t('hot-topic-studio-fallback-left-3', locale)
  ],
  rightItems: (locale?: string) => [
    t('hot-topic-studio-fallback-right-1', locale),
    t('hot-topic-studio-fallback-right-2', locale),
    t('hot-topic-studio-fallback-right-3', locale)
  ],
  twoColTitle: (locale?: string) => t('hot-topic-studio-fallback-two-col-title', locale),
  twoColLeft: (locale?: string) => t('hot-topic-studio-fallback-two-col-left', locale),
  twoColRight: (locale?: string) => t('hot-topic-studio-fallback-two-col-right', locale),
  twoColItems: (locale?: string) => [
    t('hot-topic-studio-fallback-two-col-1', locale),
    t('hot-topic-studio-fallback-two-col-2', locale),
    t('hot-topic-studio-fallback-two-col-3', locale)
  ],
  /** Same chip wording as classic StatHighlight. */
  statChip: (content: StudioPageContent, locale?: string) =>
    content.eyebrow ||
    t(content.label ? 'hot-topic-studio-stat-number-to-know' : 'hot-topic-studio-stat-key-figure', locale)
};

export const resolveComparisonContent = (content: StudioPageContent, locale?: string) => ({
  title: content.title || studioCopy.readyForward(locale),
  leftTitle: content.leftTitle || studioCopy.notGoodToGo(locale),
  rightTitle: content.rightTitle || studioCopy.goodToGo(locale),
  leftItems: Array.isArray(content.leftItems) ? content.leftItems : studioCopy.leftItems(locale),
  rightItems: Array.isArray(content.rightItems) ? content.rightItems : studioCopy.rightItems(locale)
});

const asPointItems = (value: unknown, fallback: string[]): string[] =>
  Array.isArray(value) ? value.map(item => (item == null ? '' : String(item))) : fallback;

export const resolveTwoColumnContent = (content: StudioPageContent, locale?: string) => ({
  title: content.title || studioCopy.twoColTitle(locale),
  leftTitle: content.leftTitle || studioCopy.twoColLeft(locale),
  rightTitle: content.rightTitle || studioCopy.twoColRight(locale),
  leftItems: asPointItems(content.leftItems, studioCopy.twoColItems(locale)),
  rightItems: asPointItems(content.rightItems, studioCopy.twoColItems(locale))
});
